import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestCandidateCertificate} from "../../shared/Api";
import {errorToast, infoToast, successToast} from "../../shared/helper/ToastHelper";
import {AutomatedCandidateDataDto, CandidateDataDto} from "../../shared/model/Dto";
import {teacherKeys} from "../../shared/QueryKeys";
import {saveByteArray, toIsoString} from "../../shared/Utils";

type DownloadCertificateProps = {
  username: string;
  name: string;

  readingC:  CandidateDataDto | null;
  listeningC:  CandidateDataDto | null;
  speakingC: CandidateDataDto | AutomatedCandidateDataDto | null;
  writingC: CandidateDataDto | AutomatedCandidateDataDto | null;
};

const DownloadCandidateCertificate = (props: DownloadCertificateProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const today: string = toIsoString(new Date()).slice(0, 10);

  const speakingIsLocal = props.speakingC !== null && "token" in props.speakingC;
  const writingIsLocal = props.writingC !== null && "token" in props.writingC;

  const speakingToken = props.speakingC === null? "" : "token" in props.speakingC ?
   props.speakingC.token : props.speakingC.testName ;
  const writingToken = props.writingC === null? "" : "token" in props.writingC ?
   props.writingC.token : props.writingC.testName ;

  const downloadResults = useMutation(()=>
    {
      infoToast(toast, "Procesando constancia");
      return requestCandidateCertificate(props.username,
                                props.readingC === null? "" : props.readingC.token,
                                props.listeningC === null? "" : props.listeningC.token,
                                speakingToken, writingToken,
                                speakingIsLocal, writingIsLocal)
    }, {
    onSuccess: (TData) => {
      successToast(toast, "Descargando constancia");
      saveByteArray(props.name+"-"+today, TData.data);
      return queryClient.invalidateQueries(teacherKeys.userCertificates());
    },
    onError: () => {
      errorToast(toast, "Error descargando constancia");
    },
  });

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}/>

        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar constancia</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadResults.mutate()}
              >
                Descargar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadCandidateCertificate;
